import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import InfiniteScrollSelect from "../../../components/InfiniteScrollSelect";
import { useNavigate } from "react-router-dom";

const generateInvoiceSchema = yup.object({
  // ex: 2022-01
  month: yup.string().required("Ce champ est obligatoire"),
  partnerId: yup
    .object()
    .required("Ce champ est obligatoire")
    .typeError("Ce champ est obligatoire"),
});

export function GenerateInvoiceModal({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const {
    control: formControl,
    handleSubmit,
    register: registerFormField,
    formState: { errors: formErrors },
  } = useForm({
    resolver: yupResolver(generateInvoiceSchema),
  });

  const onSubmitHandler = async (data: any) => {
    navigate(`/invoices/new/${data.month}/${data.partnerId.id}`);
  };

  return (
    <div className="p-4">
      <div className="border-bottom border-success">
        <h4>Générer une facture</h4>
      </div>
      <form className="row form mt-2" onSubmit={handleSubmit(onSubmitHandler)}>
        {/* form inputs */}
        <div className="col-md-12 mt-3">
          <label htmlFor="fullName" className="d-block">
            Mois
          </label>
          <input
            type="month"
            className="custom-input"
            id="month"
            {...registerFormField("month")}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label htmlFor="fullName" className="d-block">
            Partenaire
          </label>
          <Controller
            name="partnerId"
            control={formControl}
            render={({ field }) => {
              return (
                <InfiniteScrollSelect
                  id="partnerId"
                  isClearable={false}
                  error={formErrors?.partnerId?.message}
                  getOptionLabel={(option: any) => option?.fullName}
                  getOptionValue={(option: any) => option.id}
                  isOptionSelected={(option: any, selectedValue: any) => {
                    const isSelected = option?.id === selectedValue?.[0]?.id;
                    return isSelected;
                  }}
                  url={{
                    path: "users/place-manager",
                  }}
                  {...field}
                />
              );
            }}
          />
          {formErrors?.partnerId?.message && (
            <div
              className="text-red-500 text-opacity-50"
              style={{ color: "red" }}
            >
              {formErrors?.partnerId?.message}
            </div>
          )}
        </div>
        {/* buttons */}
        <section className="d-flex justify-content-center buttons gap-4 mt-5">
          <button
            className="btn btn-danger red-shadow w-20 px-4 py-2 shadow-primary text-white"
            type="button"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            className="btn btn-primary text-white shadow-secondary w-20 px-4"
            type="submit"
          >
            Suivante
          </button>
        </section>
      </form>
    </div>
  );
}
